const TRUTHY = new Set(['1', 'true', 'yes', 'on']);

function readBoolEnv(raw: string | undefined, defaultValue: boolean): boolean {
  if (raw === undefined || raw.trim() === '') {
    return defaultValue;
  }
  return TRUTHY.has(raw.trim().toLowerCase());
}

/** CFB.1 — frontend mirror of ENABLE_CFB_UPLOAD_OPTION (default false). */
export function isCfbUploadOptionEnabled(): boolean {
  return readBoolEnv(process.env.REACT_APP_ENABLE_CFB_UPLOAD_OPTION, false);
}

export type GameSelectOption = {
  value: string;
  label: string;
};

/** Build upload game dropdown options; Madden always available, CFB gated. */
export function buildGameSelectOptions(cfbUploadEnabled: boolean): GameSelectOption[] {
  const options: GameSelectOption[] = [
    { value: '', label: 'Select a game' },
    { value: 'Madden', label: 'Madden' },
  ];
  if (cfbUploadEnabled) {
    options.push({ value: 'College Football', label: 'College Football' });
  }
  return options;
}
